import { render, staticRenderFns } from "./cost-threshold-inputs.vue?vue&type=template&id=792d7d45&scoped=true"
import script from "./cost-threshold-inputs.vue?vue&type=script&lang=js"
export * from "./cost-threshold-inputs.vue?vue&type=script&lang=js"
import style0 from "./cost-threshold-inputs.vue?vue&type=style&index=0&id=792d7d45&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "792d7d45",
  null
  
)

export default component.exports